import React, { useState, useRef } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import Btn from '../ui/Btn';
import Spinner from '../ui/Spinner';
import { addComment } from '../../api/ticketApi';

const MAX_LENGTH = 5000;

export default function AddCommentForm({ ticketId, onCommentAdded }) {
  const [body, setBody] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const textareaRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!body?.trim()) {
      setError('Comment cannot be empty');
      return;
    }
    setIsLoading(true);
    try {
      const comment = await addComment(ticketId, body.trim());
      onCommentAdded?.(comment);
      setBody('');
    } catch (err) {
      setError(err?.json?.message || err?.json?.error || 'Failed to add comment.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    setBody(e.target.value.slice(0, MAX_LENGTH));
    const ta = e.target;
    ta.style.height = 'auto';
    ta.style.height = `${Math.min(ta.scrollHeight, 300)}px`;
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <TextField
        fullWidth
        multiline
        minRows={3}
        placeholder="Add a comment..."
        value={body}
        onChange={handleChange}
        inputRef={textareaRef}
        disabled={isLoading}
        inputProps={{ maxLength: MAX_LENGTH, 'aria-label': 'Add a comment' }}
        sx={{ '& textarea': { overflowY: 'hidden' } }}
        error={Boolean(error)}
        helperText={error}
      />
      <Typography variant="caption" sx={{ display: 'block', mt: 0.5 }} aria-live="polite">
        {MAX_LENGTH - body.length} characters remaining
      </Typography>
      <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
        <Btn attrBtn={{ type: 'submit', disabled: isLoading }}>
          {isLoading ? <Spinner size={20} /> : 'Submit'}
        </Btn>
      </Box>
    </Box>
  );
}

export function focusAddCommentForm(ref) {
  ref?.current?.focus?.();
}
